import { exportKeyAsHex } from "../dataEncryption";
import { uploadFileWithMpcWallet } from "../dwclient/dwcommonutils";
import { jwtUploadFileAndMessageReturnsJson } from "../dwclient/jwtcomm";
const apiVersion = process.env.API_VERSION || "1.0";
export const dataimportJwt = async (provider, authToken, importType, file, onProgress) => {
    const userKey = await exportKeyAsHex(provider);
    const sendObject = {
        importType: importType,
        userEncryptionKey: userKey,
    };
    return await jwtUploadFileAndMessageReturnsJson("post", `/api/${apiVersion}/graph/import`, authToken, sendObject, file, onProgress);
};
export const dataimport = async (storageProps, importType, file) => {
    return await saveDumpFileWithParams(storageProps.portalClientId ?? "", storageProps.clientSessionToken ?? "", storageProps.ed25519UserShare ?? "", importType, file);
};
const saveDumpFileWithParams = async (portalClientId, clientSessionToken, userShare, importType, file) => {
    const sendObject = {
        method: "post",
        endpoint: `/api/${apiVersion}/graph/import`,
        clientId: portalClientId,
        importType: importType,
        userEncryptionKey: "",
    };
    await uploadFileWithMpcWallet(clientSessionToken, userShare, sendObject, file, process.env.DWINITY_BACKEND ?? process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com");
};
